import { BenefitType, TypeLimit, BenefitRecord } from './types';

/**
 * 获取类型文本
 */
export const getBenefitTypeText = (type: BenefitType | number): string => {
  const typeMap: Record<number, string> = {
    [BenefitType.FREE_GENERATION]: '免费生图',
    [BenefitType.AVATAR_FRAME]: '头像框',
    [BenefitType.HD_DOWNLOAD]: '图片高清下载',
    [BenefitType.EXPOSURE]: '作品曝光',
    [BenefitType.SPEED_BOOST]: '速度提升',
    [BenefitType.NICKNAME]: '昵称',
    [BenefitType.EXCLUSIVE_STYLE]: '专属风格包',
    [BenefitType.MULTI_IMAGE]: '多图输出',
    [BenefitType.DATA_PACKAGE]: '流量包',
    [BenefitType.OTHER]: '其它',
  };
  return typeMap[type] || '未知';
};

/**
 * 获取类型限制文本
 */
export const getTypeLimitText = (typeLimit: string, type: BenefitType | number): string => {
  if (!typeLimit) return '-';
  const limitTypeMap: Record<TypeLimit, string> = {
    [TypeLimit.FREE_GENERATION_COUNT]: '免费生图张数',
    [TypeLimit.AVATAR_FRAME_URL]: '头像框地址',
    [TypeLimit.HD_DOWNLOAD_COUNT]: '图片高清下载次数',
    [TypeLimit.EXPOSURE_PERCENTAGE]: '作品曝光百分比',
    [TypeLimit.SPEED_BOOST_COUNT]: '速度提升张数',
    [TypeLimit.NICKNAME_EFFECT]: '昵称效果',
    [TypeLimit.EXCLUSIVE_STYLE_PACK]: '专属风格包',
    [TypeLimit.MULTI_IMAGE_OUTPUT]: '多图输出',
    [TypeLimit.OTHER]: '其它',
  };

  // 根据 type 确定 typeLimit 的类型
  const limitType = type as TypeLimit;
  const limitLabel = limitTypeMap[limitType] || '限制值';
  return `${limitLabel}: ${typeLimit}`;
};

/**
 * 获取状态文本和颜色
 */
export const getStatusInfo = (status: number) => {
  const statusMap: Record<number, { text: string; color: string }> = {
    0: { text: '禁用', color: 'error' },
    1: { text: '启用', color: 'success' },
  };
  return statusMap[status] || { text: '未知', color: 'default' };
};

export const mapBenefitFormDataToApi = (formData: BenefitRecord) => {
  // 这里可以根据实际API需求进行数据转换
  return {
    ...formData,
    // 假设 benefitAvatarFram 存储的是 productStockId 数组，如果API需要其他格式，在这里转换
    // benefitAvatarFram: JSON.stringify(formData.benefitAvatarFram),
  };
};
